export const initCharCountBuyerNotes = () => {
  const buyerNotes = document.getElementById("inspection_buyer_notes");
  if (buyerNotes) {
    const counter = document.getElementById("js-counter");
    const maxLength = parseInt(counter.dataset.maximumLength, 10);
    counter.innerText = maxLength - buyerNotes.textLength;

    buyerNotes.addEventListener('keyup', () => {
      const diff = maxLength - buyerNotes.textLength;
      counter.innerText = diff > 0 ? diff : 'Too many characters';
    })
  }
}


